import { FulfillmentTile } from '@libs/shared-ui';

import { useSddDeliveryTile } from '../../model';

export const SddDeliveryTile = () => {
    const { isLoading, isDisabled, status, selectedDeliveryMethod, register } = useSddDeliveryTile();

    return (
        <FulfillmentTile
            value="sdd"
            title="Same-day delivery"
            iconName="box-outline"
            status={status}
            statusTestId="sdd-tile-status-message"
            isSelected={selectedDeliveryMethod === 'sdd' && !isLoading && !isDisabled}
            isDisabled={isDisabled}
            isLoading={isLoading}
            inputProps={register}
        />
    );
};
